import { Stepper as MuiStepper } from '@mui/material'
import React from 'react'

import { StepperProps } from './stepper.types'

export const Stepper: React.FC<StepperProps> = ({ children, ...rest }) => {
  return <MuiStepper {...rest}>{children}</MuiStepper>
}
